<template>
    <div>
        <h6 class="heading-small text-muted mb-4">{{ $translate('signature') }}</h6>

        <template v-if="!!order.signature_data">
            <b-row>
                <img :src="order.signature_data" />
            </b-row>
            <hr />
            <b-row class="pt-2">
                <b-col cols="2">
                    <strong>{{ $translate('comments')+':' }}</strong>
                </b-col>
                <b-col>{{ order.signee }}</b-col>
            </b-row>
            <b-row class="pt-2">
                <b-col cols="2">
                    <strong>{{ $translate('signature_by') }}</strong>
                </b-col>
                <b-col>{{ order.completed_by.first_name +' '+order.completed_by.last_name }}</b-col>
            </b-row>
            <b-row class="pt-2">
                <b-col cols="2">
                    <strong>{{ $translate('signed_at') }}</strong>
                </b-col>
                <b-col>{{ signature_address && signature_address[0]&&signature_address[0].display_name }}</b-col>
            </b-row>
            <b-row class="pt-2">
                <b-col cols="2">
                    <strong>{{ $translate('completed') }}:</strong>
                </b-col>
                <b-col>{{ order.completed_at }}</b-col>
            </b-row>
        </template>
        <div v-else-if="order.signature === 0" style="padding: 1em 0; text-align: center">
            {{ $translate('received_by_note') }}
        </div>
        <div v-else style="padding: 1em 0; text-align: center">
            {{ $translate('no_signature_data') }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'orders-signature',
    data() {
        return {
            signature_address: null
        }
    },
    props: {
        order: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    methods: {},
    mounted() { },
    computed: {
        imagedata() {
            if (this.order) {
                return 'data:image/png;base64,' + this.order.signature_data
            } else {
                return null
            }
        },
    },
    watch: {
        order: {
            immediate: true,
            handler: async function (val) {
                const getAddress = await this.$store.dispatch(
                    'orders/geocodeStreet',
                    { lat: val.signature_lat, long: val.signature_long }
                )
                this.signature_address = getAddress
            }
        },
    },
}
</script>

<style lang="scss" scoped></style>